import React from "react";
import {connect} from "react-redux";
import {loadContentWriterProject, saveContentWriterProject} from "../../actions/content_writer";
import {Button, Col, Collapse, Form, Input, message, Modal, Row, Select, Space, Tabs} from "antd";
import {displayErrors} from "../../libs/utils";
import {Loading} from "../../libs/loading";

class ProjectSettings extends React.Component {
    state = {
        loading: false,
        name: '',
        tags: [],

        loadingData: false,
        dataLoaded: false,
        saving: false,

        showPersonaGeneratorModal: false,
        persona_name: '',
        persona_history: '',
        persona_writing_style: '',
        persona_voice_tone: '',
        persona_target_audience: '',
        persona_personal_values: '',
        persona_example_phrases: '',
        persona_personality: ''
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.showModal && !this.state.dataLoaded && !this.state.loadingData) {
            this.loadSettings();
        }
    }

    loadSettings() {
        this.setState({ loadingData: true });

        this.props.loadContentWriterProject(this.props.projectId, (res) => {
            this.setState({ dataLoaded: true, loadingData: false, ...res.data });
        }, (err) => {
            this.setState({ dataLoaded: true, loadingData: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    closeModal(reload = false) {
        this.setState({
            loading: false,
            name: '',
            tags: [],

            loadingData: false,
            dataLoaded: false,
            saving: false,

            showPersonaGeneratorModal: false,
            persona_name: '',
            persona_history: '',
            persona_writing_style: '',
            persona_voice_tone: '',
            persona_target_audience: '',
            persona_personal_values: '',
            persona_example_phrases: '',
            persona_personality: ''
        }, () => {
            this.props.close();

            if(reload) {
                this.props.reload();
            }
        });
    }

    saveSettings() {
        if(this.state.name.trim().length === 0) {
            return message.error('Please enter the project name!');
        }

        let data = {
            name: this.state.name.trim(),
            tags: this.state.tags,
            persona_name: this.state.persona_name,
            persona_history: this.state.persona_history,
            persona_writing_style: this.state.persona_writing_style,
            persona_voice_tone: this.state.persona_voice_tone,
            persona_target_audience: this.state.persona_target_audience,
            persona_personal_values: this.state.persona_personal_values,
            persona_example_phrases: this.state.persona_example_phrases,
            persona_personality: this.state.persona_personality,
        };

        this.setState({ saving: true });

        this.props.saveContentWriterProject(this.props.projectId, data, () => {
            message.success('Project saved successfully!');
            this.closeModal(true);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ saving: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { TextArea } = Input;
        const { Panel } = Collapse;

        const generalTab = <Form layout='vertical'>
            <Form.Item label='Name'>
                <Input value={this.state.name} onChange={(e) => this.setState({ name: e.target.value })} />
            </Form.Item>
            <Form.Item label='Tags'>
                <Select
                    mode='tags' allowClear value={this.state.tags}
                    onChange={(values) => this.setState({ tags: values })}/>
            </Form.Item>
        </Form>;

        const personaTab = <Row>
            <Col span={24}>
                <Form layout='vertical'>
                    <Form.Item label={<span>Persona's name</span>}>
                        <Input value={this.state.persona_name} onChange={(e) => this.setState({ persona_name: e.target.value })} />
                    </Form.Item>
                </Form>
                <p>The fields below are optional, but we strongly recommend filling them out to keep your content unique and consistent in style.</p>
                <Collapse>
                    <Panel header='Personality' key='personality'>
                        <TextArea value={this.state.persona_personality} rows={3} onChange={(e) => this.setState({ persona_personality: e.target.value })} />
                    </Panel>
                    <Panel header='History' key='history'>
                        <TextArea value={this.state.persona_history} rows={3} onChange={(e) => this.setState({ persona_history: e.target.value })} />
                    </Panel>
                    <Panel header='Personal values' key='personal-values'>
                        <TextArea value={this.state.persona_personal_values} rows={3} onChange={(e) => this.setState({ persona_personal_values: e.target.value })} />
                    </Panel>
                    <Panel header='Writing style' key='writing-style'>
                        <TextArea value={this.state.persona_writing_style} rows={3} onChange={(e) => this.setState({ persona_writing_style: e.target.value })} />
                    </Panel>
                    <Panel header='Voice & tone' key='voice-tone'>
                        <TextArea value={this.state.persona_voice_tone} rows={3} onChange={(e) => this.setState({ persona_voice_tone: e.target.value })} />
                    </Panel>
                    <Panel header='Example phrases' key='example-phrases'>
                        <TextArea value={this.state.persona_example_phrases} rows={3} onChange={(e) => this.setState({ persona_example_phrases: e.target.value })} />
                    </Panel>
                    <Panel header='Target audience' key='target-audience'>
                        <TextArea value={this.state.persona_target_audience} rows={3} onChange={(e) => this.setState({ persona_target_audience: e.target.value })} />
                    </Panel>
                </Collapse>
            </Col>
        </Row>;

        const tabs = [
            {key: 'general', label: 'General', children: generalTab},
            {key: 'persona', label: 'Persona', children: personaTab},
        ]

        return <Modal
            centered
            title='Project Settings'
            open={this.props.showModal}
            destroyOnClose={true}
            footer={<Space>
                <Button type='primary' onClick={() => this.saveSettings()} disabled={this.state.saving} loading={this.state.saving}>Save</Button>
            </Space>}
            onCancel={() => this.closeModal()}>
            {this.state.loadingData ? <div className='text-center'><Loading /></div> : <Tabs items={tabs} />}
        </Modal>;
    }
}

export default connect(null, { loadContentWriterProject, saveContentWriterProject })(ProjectSettings);